import { getController } from '@/services/service'

const url = 'phonenumbers'
export const phonenumberService = {
	...getController<
		Api.PhoneNumber,
		Api.PhoneNumberPostInput,
		Api.PhoneNumberUpdateInput
	>(url),
}

export default phonenumberService
